var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNavigationDownDarkBackground(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Navigation",
    xmlns: "http://www.w3.org/2000/svg",
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_157145",
    "data-name": "Rectangle 157145",
    width: 38,
    height: 38,
    rx: 8,
    transform: "translate(38) rotate(90)",
    fill: "#2e4d7b"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2",
    transform: "translate(7 7)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "invisible_box",
    "data-name": "invisible box"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_157085",
    "data-name": "Rectangle 157085",
    width: 24,
    height: 24,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Q3_icons",
    "data-name": "Q3 icons",
    transform: "translate(-6.661 -6.284)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73708",
    "data-name": "Path 73708",
    d: "M10.372,19.826,17.8,27.188a1.175,1.175,0,0,0,1.732,0l7.424-7.362a1.3,1.3,0,0,0,.124-1.67,1.175,1.175,0,0,0-1.856-.124l-5.32,5.32V10.237a1.237,1.237,0,1,0-2.475,0V23.352l-5.32-5.32a1.175,1.175,0,0,0-1.856.124A1.3,1.3,0,0,0,10.372,19.826Z",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavigationDownDarkBackground);
export default __webpack_public_path__ + "static/media/NavigationDownDarkBackground.56d8cb223906b3cafe9c784a3eaae00f.svg";
export { ForwardRef as ReactComponent };